import * as types from './types';

export const fetchAll = (subId) => ({
  type: types.FETCH_ALL,
  payload: { subId }
});

export const find = (id) => ({
  type: types.FIND,
  payload: { id }
});
